import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { debugFlagActions, fromDebugFlags, DebugFlagsService } from '@content-platform/web-angular-shared-util-development';

import { DebugFlagsDialogComponent } from '../debug-flags-dialog/debug-flags-dialog.component';

@Injectable()
export class DebugFlagsDialogService {
  constructor(
    private store: Store<fromDebugFlags.State>,
    private dialog: MatDialog,
    private debugFlagsService: DebugFlagsService
  ) {}

  showDebugFlagsModal() {
    const dialogRef = this.dialog.open(DebugFlagsDialogComponent, {
      width: '400px',
      data: { flags: this.debugFlagsService.flags, settings: this.debugFlagsService.settings },
      disableClose: true,
      panelClass: 'debug-flag'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.store.dispatch(new debugFlagActions.Set(result));
      }
    });
  }
}
